
import AccountSettingsMainPage from './AccountSettingsMainPage';
import BasicSettingsPage from './basic/BasicSettingsPage';
import PreferenceSettingsMainPage from './preferences/PreferenceSettingsMainPage';
import TransactionHistorySettingsPage from './transactionHistory/TransactionHistorySettingsPage';
import TransactionReceipt from './transactionHistory/TransactionReceipt';
import ReceiptMemberDetails from './transactionHistory/ReceiptMemberDetails';
import LocationPreferences from './location/LocationPreferences';

export {
    AccountSettingsMainPage,
    BasicSettingsPage,
    PreferenceSettingsMainPage,
    TransactionHistorySettingsPage,
    TransactionReceipt,
    LocationPreferences,
    ReceiptMemberDetails,
};


// WEBPACK FOOTER //
// src/client/components/site/features/account/index.js